
const initialState = {
  product_list: [],
  dashboard_recentproduct: [],
  dashboard_expiredproduct: [],
  saleshdashboard_recenttransaction: [],
  layoutstyledata: []
};

export default initialState;